import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'
import { Stats } from 'components/common/StatList'
import clsx from 'clsx'

export default function TrustSection({
	_rawIntro,
	valueProps,
	stats,
	logos,
	testimonial,
	testimonialOnLeft,
}) {
	return (
		<section className="padding mx-auto grid max-w-screen-lg items-center gap-12 md:grid-cols-2">
			<header
				className={clsx(
					'space-y-8 border-line <md:border-b <md:pb-12 [.bg-gradient-to-br_&]:md:border-ft-green-light',
					testimonialOnLeft ? 'md:border-l md:pl-12' : 'md:border-r md:pr-12',
				)}
			>
				<SanityBlock body={_rawIntro} />

				{!!valueProps?.length && (
					<ul className="space-y-6">
						{valueProps.map(({ _rawContent, icon, _key }) => (
							<li className="flex items-start gap-4" key={_key}>
								<figure className="shrink-0">
									<Img className="h-[40px] w-auto" image={icon} />
								</figure>

								<SanityBlock className="!space-y-2" body={_rawContent} />
							</li>
						))}
					</ul>
				)}

				{!!stats?.length && (
					<dl
						className={clsx(
							'mx-auto grid max-w-screen-md grid-cols-2 gap-4 md:grid-cols-3',
						)}
					>
						{stats?.map(({ number, text }, key) => (
							<div className="space-y-2" key={key}>
								<dt className="items-center gap-1 text-5xl text-ft-green">
									{number}
								</dt>
								<dd className="technical text-sm">{text}</dd>
							</div>
						))}
					</dl>
				)}
			</header>

			<div className={clsx('space-y-8', testimonialOnLeft && 'md:order-first')}>
				<figure className="flex items-center gap-4 md:gap-8 [.bg-gradient-to-br_&]:grayscale">
					{logos?.map(({ name, image, _key }) => (
						<Img
							className="[&:not(:first-child)]:max-w-[60px]"
							image={image?.original}
							alt={name}
							key={_key}
						/>
					))}
				</figure>

				<blockquote className="space-y-4">
					<SanityBlock
						className="text-xl font-bold !leading-tight"
						body={testimonial._rawQuote}
					/>

					<dl className="space-y-2 text-sm">
						{testimonial.image && (
							<figure>
								<Img
									className="max-w-[40px] overflow-hidden rounded-full"
									image={testimonial.image}
									alt={testimonial.author}
								/>
							</figure>
						)}
						<dt>{testimonial.author}</dt>
						<dd className="text-ink-light">{testimonial.title}</dd>
					</dl>
				</blockquote>
			</div>
		</section>
	)
}
